/**
 * Footer Component - Stroyma
 * Inspired by Filmshúsið design
 */

import { t } from '../lib/i18n.js';

export function createFooter() {
  const footer = document.createElement('footer');
  footer.className = 'footer';

  footer.innerHTML = `
    <div class="footer-content">
      <div class="footer-section footer-info">
        <p class="footer-description">${t('footer_description')}</p>
        <div class="footer-contact-wrapper">
          <img src="https://www.filmshusid.fo/wp-content/themes/films/assets/images/logo.svg" alt="Filmshúsið" class="footer-filmshusid-logo">
          <div class="footer-contact">
            <div class="footer-contact-item">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" class="footer-icon">
                <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
              </svg>
              <span>${t('footer_address')}</span>
            </div>
            <div class="footer-contact-item">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" class="footer-icon">
                <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
              </svg>
              <span>${t('footer_phone')}</span>
            </div>
            <div class="footer-contact-item">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" class="footer-icon">
                <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
              </svg>
              <span>${t('footer_email')}</span>
            </div>
          </div>
        </div>
      </div>
      
      <div class="footer-section footer-links">
        <ul class="footer-links-list">
          <li><a href="/terms" class="footer-link" data-link>${t('footer_terms')}</a></li>
          <li><a href="/privacy" class="footer-link" data-link>${t('footer_privacy')}</a></li>
          <li><a href="/about" class="footer-link" data-link>${t('footer_about')}</a></li>
        </ul>
      </div>
      
      <div class="footer-section footer-built">
        <a href="https://usable.dev" target="_blank" rel="noopener noreferrer" class="footer-built-logo">
          <span class="footer-built-text">${t('footer_built_with')}</span>
          <span class="footer-built-brand">Usable</span>
        </a>
      </div>
    </div>
    
    <div class="footer-bottom">
      <p class="footer-copyright">${t('footer_copyright')}</p>
      <a href="https://admin.stroyma.fo" target="_blank" rel="noopener noreferrer" class="footer-admin-link">${t('footer_admin_login')}</a>
    </div>
  `;

  return footer;
}
